import React from 'react';
import { NetworkIcon, ExternalLinkIcon } from 'lucide-react';
const TelecomsContext = () => {
  return <section className="py-16 bg-white border-b border-gray-200" data-id="element-416">
      <div className="container mx-auto px-4" data-id="element-417">
        <div className="max-w-4xl mx-auto" data-id="element-418">
          <div className="text-center mb-8" data-id="element-419">
            <div className="inline-block p-4 bg-[#e5f8f7] rounded-full mb-4" data-id="element-420">
              <NetworkIcon className="h-12 w-12 text-[#54d4cb]" data-id="element-421" />
            </div>
            <h2 className="text-3xl font-bold mb-6" data-id="element-422">
              Telecom Operators Are Essential To The Next Wave Of AI Adoption
            </h2>
          </div>
          <div className="bg-gray-50 rounded-lg p-8 mb-6" data-id="element-423">
            <p className="text-lg text-gray-700 mb-4" data-id="element-424">
              The next generation of AI adoption is entirely in the hands of
              telecom operators. An estimated{' '}
              <span className="font-semibold text-[#2d8a84]" data-id="element-425">
                2 billion people
              </span>{' '}
              will be able to use AI only if mobile network operators (MNOs)
              play a role in providing connectivity.
            </p>
            <p className="text-lg text-gray-700" data-id="element-426">
              Current MNO operators are already getting into AI, but by
              cross-selling a 3rd party product, rather than providing their own
              branded one through a partner like us.
            </p>
          </div>
          <div className="bg-gradient-to-r from-[#54d4cb] to-[#3ba69f] rounded-lg p-6 text-white" data-id="element-427">
            <div className="flex items-start" data-id="element-428">
              <div className="flex-shrink-0 mr-4" data-id="element-429">
                <ExternalLinkIcon className="h-6 w-6" data-id="element-430" />
              </div>
              <div data-id="element-431">
                <h3 className="text-xl font-semibold mb-2" data-id="element-432">Research Insight</h3>
                <p className="mb-3" data-id="element-433">
                  Article from the Center For Global Development highlights
                  this:
                </p>
                <a href="https://www.cgdev.org/blog/sms-charges-may-be-inhibiting-use-ai-1-billion-people" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-white hover:text-[#e3f7f6] underline font-medium" data-id="element-434">
                  SMS Charges May Be Inhibiting the Use of AI for 1 Billion
                  People
                  <ExternalLinkIcon className="h-4 w-4 ml-1" data-id="element-435" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default TelecomsContext;